.ux-iws-location-selection__selection-accordion {
    ux-icon[name="chevron-down"] {
        display: none;
    }

    .ux-accordion__title-container {
        padding: 0 !important;
        border-bottom: 0;
    }

    .ux-accordion__content-container {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    *[slot="title"] {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        max-width: 100%;
    }
}

.ux-iws-location-selection__locations {
    a {
        text-decoration: none;
        color: $color-black;

        &:hover {
            color: $color-green;
        }
    }

    ul {
        padding-left: 5px;
        margin-top: 5px;
        margin-bottom: 15px;
        list-style: none;
        display: flex;
        flex-wrap: wrap;
    }

    ul > * {
        width: 100%;

        @media only screen and (min-width: $gridle-t-max) {
            width: 40%;
        }
    }

    li {
        float: left;
    }
}
